import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';
import paginationParams from 'utils/pagination-params';

export const list = 'LIST_REFERRALS';
export const single = 'SINGLE_REFERRAL';

export const referralsApi = createApi({
  reducerPath: 'referralsApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    generateReferralLink: builder.mutation({
      query: ({ requisitionId, name, email }) => ({
        url: `/referrals/create`,
        method: 'POST',
        body: { requisitionId, name, email }
      })
    }),
    listReferrals: builder.query({
      query: (params) => ({
        url: '/referrals/list',
        params
      }),
      providesTags: [list],
      transformResponse: (res) => {
        if (res.data?.items && res.data?.items?.length) {
          res.data.items = res.data.items.map((item) => ({
            ...item,
            id: item.applicantId ? item.applicantCreatedAt : item.id
          }));
        }
        return res;
      },
      ...paginationParams
    }),
    exportReferrals: builder.query({
      query: (params) => ({
        url: '/referrals/export',
        params,
        responseHandler: (response) => response.text()
      })
    }),
    getReferralById: builder.query({
      query: (referralId) => `/referrals/get/${referralId}`,
      providesTags: [single]
    }),
    getReferralByToken: builder.query({
      query: (token) => `/referrals/validate/${token}`
    }),
    trackReferralApplicant: builder.mutation({
      query: ({ token, applicantId }) => ({
        url: `/referrals/track`,
        method: 'POST',
        body: { token, applicantId }
      }),
      invalidatesTags: [list]
    })
  })
});

export const {
  useGenerateReferralLinkMutation,
  useListReferralsQuery,
  useLazyExportReferralsQuery,
  useGetReferralByIdQuery,
  useGetReferralByTokenQuery,
  useTrackReferralApplicantMutation
} = referralsApi;
